import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    base: {
        height: '100%',
        width: '100%',
    },
    root: {
        position: 'absolute',
        height: '100%',
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(0, 2),
        backgroundColor: theme.palette.primary.main,
    },
    card: {
        width: '420px',
        maxWidth: '100%',
        overflow: 'visible',
        display: 'flex',
        position: 'relative',
        '& > *': {
            flexGrow: 1,
            flexBasis: '50%',
            width: '50%',
        },
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(6),
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        marginTop: 16,
        marginBottom: 16,
        color: '#444',
    },
    dialogTitle: {
        background: theme.palette.primary.main,
        color: 'white',
        fontWeight: 'bold',
    },
    dialogActions: { margin: '0px 16px 16px 16px' },
    dialogContent: {},
    dialogContentText: {},
    submitButton: {
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(2),
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        width: '100%',

        '&:hover': {
            backgroundColor: theme.palette.primary.light,
        },
    },
    textInput: { marginTop: 8, marginBottom: 8 },
}));
